import Api from '@/services/Api'

export default {
  getCompanyById (id) {
    return Api().get('/company/' + id + '/public')
  },
  getAllPosts (id, params) {
    return Api().get('/company/' + id + '/posts', {params})
  },
  writeReview (id, vote, text, source) {
    return Api().post('/company/' + id + '/review/write', {vote, text, source})
  }
}



// WEBPACK FOOTER //
// ./src/services/CompanyService.js